import React from "react";

const STATUS_CONFIG: Record<string, { badge: string; label: string }> = {
  completed: { badge: "success", label: "✓ Completed" },
  "in-progress": { badge: "warning", label: "🔄 In Progress" },
  pending: { badge: "warning", label: "⏳ Pending" },
  "not-started": { badge: "warning", label: "⚪ Not Started" },
  failed: { badge: "error", label: "✗ Withdrawn" },
};

const RISK_CONFIG: Record<string, { badge: string; label: string }> = {
  low: { badge: "success", label: "🟢 Low" },
  medium: { badge: "warning", label: "🟡 Medium" },
  high: { badge: "error", label: "🔴 High" },
};

export const StatusBadge: React.FC<{ status: string }> = ({ status }) => {
  const cfg = STATUS_CONFIG[status] ?? STATUS_CONFIG.pending;
  return <span className={`badge badge-${cfg.badge}`}>{cfg.label}</span>;
};

export const RiskBadge: React.FC<{ riskLevel: string }> = ({ riskLevel }) => {
  const cfg = RISK_CONFIG[riskLevel] ?? RISK_CONFIG.high;
  return <span className={`badge badge-${cfg.badge}`}>{cfg.label}</span>;
};
